export type BootStage =
  | 'starting'
  | 'permissions'
  | 'preferences'
  | 'updater'
  | 'router'
  | 'complete';

type ReportableBootStage = Exclude<BootStage, 'complete'>;

let currentStage: BootStage = 'starting';
const listeners = new Set<() => void>();

function notify(): void {
  listeners.forEach((listener) => listener());
}

/** Records the boot gate the app has reached; ignored once boot is complete. */
export function reportBootStage(stage: ReportableBootStage): void {
  if (currentStage === 'complete' || currentStage === stage) return;
  currentStage = stage;
  notify();
}

export function markBootComplete(): void {
  if (currentStage === 'complete') return;
  currentStage = 'complete';
  notify();
}

export function getBootStage(): BootStage {
  return currentStage;
}

/** Subscription shape matches useSyncExternalStore. */
export function subscribeBootStage(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function resetBootStageForTests(): void {
  currentStage = 'starting';
  listeners.clear();
}
